<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <hm-spinner v-if="!ready" />
      </b-col>
    </b-row>

    <div v-show="ready">
      <b-row class="pt-4">
        <b-col>
          <b-table
            class="p-1"
            responsive
            bordered
            hover
            show-empty
            empty-text="No Training Events"
            :items="training"
            :fields="columns"
            :sort-by.sync="sortBy"
            :sort-desc="true"
            @row-clicked="rowClick"
          >
            <template slot="cell(date)" slot-scope="data">
              <div class="nowrap">{{data.value|formatDate('YYYY-MM-DD')}}</div>
            </template>
            <template slot="cell(desc)" slot-scope="data">
              <div class="column-min-width">{{data.value}}</div>
            </template>
            <template slot="cell(topics)" slot-scope="data">
              <div v-for="topic in data.value" :key="topic" class="nowrap">
                <i class="icon-check text-success"></i>
                {{trainingMap.Training[topic].name}}
              </div>
            </template>
            <template slot="cell(attendees)" slot-scope="data">
              <div v-for="(value, key) in data.value" :key="key" class="nowrap">{{value}}</div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <b-button type="button" variant="secondary" class="px-4" :disabled="busy" to="/training-docs">Back</b-button>
        </b-col>
        <b-col cols="6" class="text-right"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { trainingService } from '@/services'

export default {
  name: 'TrainingList',
  data() {
    return {
      training: [],
      sortBy: 'date',
      columns: [{
        key: 'date',
        label: 'Date',
        sortable: true
      }, {
        key: 'presenter',
        label: 'Presenter',
        sortable: true
      }, {
        key: 'desc',
        label: 'Description'
      }, {
        key: 'topics',
        label: 'Topics'
      }, {
        key: 'attendees',
        label: 'Attendees'
      }],
      ready: false
    }
  },
  computed: {
    ...mapState('maps', ['trainingMap'])
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    rowClick(record, index) {
      this.$router.push({ name: 'TrainingEdit', params: { id: record.id } });
    }
  },
  created() {
    this.ready = false;

    Promise.all([
      this.$store.dispatch('maps/fetchTrainingMap'),
      trainingService.getTraining()
    ]).then((values) => {
      this.training = values[1];
    }).catch((err) => {
      this.alertException({ err, message: 'Error loading data.' });
    }).finally(() => {
      this.ready = true;
    })
  }
}
</script>

<style scoped>
.column-min-width {
  min-width: 250px;
}
</style>